import Login from "../pages/Auth/Login";
import CandidateAccess from "../pages/Candidate/CandidateAccess/CandidateAccess";
import CandidateDeviceCheck from "../pages/Candidate/CandidateDeviceCheck/CandidateDeviceCheck";
import CandidateDisclaimer from "../pages/Candidate/CandidateDisclaimer/CandidateDisclaimer";
import Interview from "../pages/Candidate/Interview/Interview";
import InterviewCompletion from "../pages/Candidate/InterviewCompletion/InterviewCompletion";
import ViewRecording from "../pages/ViewRecording";
import ProtectPublicRoutes from "./ProtectRoutes/ProtectPublicRoutes";

export const publicRoutes = [
  {
    path: "/",
    element: (
      <ProtectPublicRoutes>
        <Login />,
      </ProtectPublicRoutes>
    ),
  },

  {
    path: "/candidate-access",
    element: <CandidateAccess />,
  },
  {
    path: "/candidate-disclaimer/:token",
    element: <CandidateDisclaimer />,
  },

  {
    path: "/device-check/:token",
    element: <CandidateDeviceCheck />,
  },
  // {
  //   path: "/candidate-disclaimer/:interviewId",
  //   element: <CandidateDisclaimer />,
  // },

  // {
  //   path: "/device-check/:interviewId",
  //   element: <CandidateDeviceCheck />,
  // },

  {
    path: "/interview",
    element: <Interview />,
  },
  {
    path: "/interview/:token",
    element: <Interview />,
  },

  {
    path: "/interview-completion/:interviewId",
    element: <InterviewCompletion />,
  },
  // Public read-only view of interview recording (shareable link for managers)
  {
    path: "/view-recording/:id",
    element: <ViewRecording />,
  },
];
